import { useContext } from '@nuxtjs/composition-api'
import useFeatureFlags from './useFeatureFlags'
import { ENABLE_LOCALIZATION } from '@/constants/featureFlags'

export default function useLocalization() {
  const { app, store } = useContext()
  const featureFlags = useFeatureFlags({
    isLocalizationEnabled: ENABLE_LOCALIZATION
  })

  const initializeLocalization = async () => {
    try {
      if (!featureFlags.isLocalizationEnabled) {
        return
      }

      const school = store.state.settings.school

      if (!school) {
        console.warn('School information not available to setup localization')
        return
      }

      // Always reset localization to defaults first to prevent cross-request contamination
      app.$updateLocalization({
        localizations: {},
        dateFormat: '',
        timeFormat: ''
      })

      const response = await app.$axios.$get(`/${school}/general/localizations`)
      const localizationSettings = response?.localizations?.[response.deafult || 'en-us']

      // Then apply school-specific localizations if they exist
      if (localizationSettings) {
        app.$updateLocalization({
          localizations: localizationSettings.localizations || {},
          dateFormat: localizationSettings.dateFormat || '',
          timeFormat: localizationSettings.timeFormat || ''
        })
      }

      return response
    } catch (error) {
      console.warn('Failed to fetch localizations:', error)
    }
  }

  return {
    initializeLocalization,
    ready: featureFlags.ready
  }
}
